import { path } from 'ramda';

import { differenceInDays } from '@shared/utils/date';

import { getOriginName } from '@/v2/utils/getOriginName';
import { getFlightsJourney } from '../formatFlightsJourney';

export const getOfferDetails = (offer) => ({
  offerId: offer.id,
});

export const getRoomDetails = (room) => ({
  roomTypeName: room.name,
});

export const getPropertyDetails = (property) => ({
  propertyName: property.name,
  propertyId: property.id,
});

export const getStayDetails = (stay) => {
  const { checkIn, checkOut } = stay;

  return {
    roomNights: differenceInDays(new Date(checkOut), new Date(checkIn)),
    numAdults: stay.adults,
    numChildren: stay.children,
    numInfants: stay.infants,
  };
};

export const getFlightsDetails = (flights) => {
  const { origin, destination } = getFlightsJourney(flights.outbound);

  return {
    originName: origin.name,
    destinationName: destination.name,
  };
};

export const getSearchDetails = (searchQuery) => {
  const { originCode, departureDate, returnDate, adults, children, infants } =
    searchQuery;

  return {
    originName: getOriginName(originCode) ?? '',
    roomNights: differenceInDays(new Date(returnDate), new Date(departureDate)),
    numAdults: adults,
    numChildren: children,
    numInfants: infants,
  };
};

export const getBookingDetails = (booking) => {
  const getPaymentBreakdownDetails = (paymentBreakdown) => ({
    pointsAmount: path(['points', 'points'], paymentBreakdown),
    voucherAmount: path(['voucher', 'total', 'amount'], paymentBreakdown),
    creditCardAmount: path(['creditCard', 'total', 'amount'], paymentBreakdown),
  });

  const getChargesDetails = (charges) => ({
    transactionTotal: charges.total.amount,
  });

  return {
    bookingId: booking.id,
    ...getOfferDetails(booking.offer),
    ...getRoomDetails(booking.roomType),
    ...getPropertyDetails(booking.property),
    ...getStayDetails(booking.stay),
    ...getFlightsDetails(booking.flights),
    ...getPaymentBreakdownDetails(booking.paymentBreakdown),
    ...getChargesDetails(booking.charges),
  };
};
